import { AlertTriangle } from "lucide-react";
import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";

interface RestoreVersionDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  versionNumber: number;
  currentVersion: number;
}

export const RestoreVersionDialog: React.FC<RestoreVersionDialogProps> = ({
  open,
  onClose,
  onConfirm,
  versionNumber,
  currentVersion,
}) => {
  const versionsToRevert = currentVersion - versionNumber;

  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            <AlertDialogTitle>
              Restore to Version {versionNumber}?
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="space-y-3 pt-2">
            <p>
              This will revert changes made in{" "}
              {versionsToRevert === 1 ? "version" : "versions"}{" "}
              {versionNumber + 1}
              {versionsToRevert > 1 && `-${currentVersion}`}.
            </p>
            <p>
              A new version (v{currentVersion + 1}) will be created as a copy of
              v{versionNumber}, preserving the full audit trail.
            </p>
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mt-3">
              <p className="text-sm text-amber-800">
                <strong>Note:</strong> No history will be deleted. All versions
                will remain accessible in the version history.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Restore Version
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
